import request from '@/_helpers/requests/requestNotif'

export const employeeService = {
    getDataEmployee() {
    
        return new Promise((resolve) => {
    
            request.get('empleado/datos').then(response => {
                resolve(response.data)
            });
        });
    },
    getDataEmployeeWithDiario() {
    
        return new Promise((resolve) => {
    
            request.get('empleado/datosDiario').then(response => {
                resolve(response.data)
            });
        });
    },
    getLineaDiarioAltas() {    
        return new Promise((resolve) => {
            request.get('empleado/getLineaDiarioAltas').then(response => {
                resolve(response.data)
            });
        });
    },
    getEstadosCiviles() {

        return new Promise((resolve) => {
    
            request.get('empleado/estadosCiviles').then(response => {
                resolve(response.data)
            });
        });
    },
    getSiglas() {
        return new Promise((resolve) => {    
            request.get('empleado/siglas').then(response => {
                resolve(response.data)
            });
        });
    },
    getPoblaciones(codProvincia) {
        return new Promise((resolve) => {    
            request.get('empleado/poblaciones/'+codProvincia).then(response => {
                resolve(response.data)
            });
        });
    },
    getProvincias(codPais) {
        return new Promise((resolve) => {    
            request.get('empleado/provincias/'+codPais).then(response => {
                resolve(response.data)
            });
        });
    },
    getPaises() {
        return new Promise((resolve) => {    
            request.get('empleado/paises').then(response => {
                resolve(response.data)
            });
        });
    },
    getNacionalidades() {
        return new Promise((resolve) => {    
            request.get('empleado/nacionalidades').then(response => {
                resolve(response.data)
            });
        });
    },
    getCamposLibres() {
        return new Promise((resolve) => {    
            request.get('empleado/camposLibres').then(response => {
                resolve(response.data)
            });
        });
    },    
    postEmployeeData(postData) {
        return new Promise((resolve) => {
    
            request.post('empleado/updateData', postData).then(response => {
                resolve(response.status == 200);
            });
        });
    }
};